'use client';

import { useLocalized } from '~/(tenant)/_components/native/_lib/use-localized';
import { useNativeTokens } from '~/(tenant)/_components/native/_lib/use-native-tokens';
import { Ornament } from '~/(tenant)/_components/native/_primitives';

import type { QuoteSectionConfig } from '~/(tenant)/_lib/schema/native-home-config.schema';

interface QuoteSectionProps {
  config: QuoteSectionConfig;
}

/**
 * Centered italic display serif quote with hairline ornament + mono
 * attribution. Emotional anchor at section breaks.
 */
export function QuoteSection({ config }: QuoteSectionProps) {
  const t = useNativeTokens();
  const text = useLocalized(config.text, config.text_ar) ?? '';
  const attribution = useLocalized(config.attribution, config.attribution_ar);

  return (
    <section
      style={{
        margin: '40px 22px 0',
        textAlign: 'center',
        padding: '24px 0',
      }}
    >
      <Ornament />
      <p
        style={{
          fontFamily: t.fontDisplay,
          fontSize: 22,
          fontWeight: 300,
          fontStyle: 'italic',
          color: t.foreground,
          lineHeight: 1.4,
          letterSpacing: '0.01em',
          marginTop: 22,
        }}
      >
        {text.split('\n').map((line, i, arr) => (
          <span key={i}>
            {`"${i === 0 ? '' : ''}${line}${i === arr.length - 1 ? '"' : ''}`}
            {i < arr.length - 1 && <br />}
          </span>
        ))}
      </p>
      {attribution && (
        <div
          style={{
            fontFamily: t.fontMono,
            fontSize: 8,
            letterSpacing: '0.22em',
            textTransform: 'uppercase',
            color: t.muted,
            marginTop: 14,
          }}
        >
          — {attribution}
        </div>
      )}
    </section>
  );
}
